/* ═══════════════════════════════════════════════════════════════════════════
   js/jk-mortgage-ready.js — ГОТОВЫЕ РАСЧЁТЫ ИПОТЕКИ над калькулятором.

   Владелец 28.08.2026 принял вид, где над блоком «Способы покупки» сразу, без
   единого клика, стоит список платежей по каждой программе — от минимальной
   цены квартиры на этой странице. Калькулятор остаётся ровно таким, каким был:
   ни один его узел не правится и не подменяется.

   ⛔⛔ СТАВКИ НЕ ХАРДКОДЯТСЯ И НЕ УГАДЫВАЮТСЯ. Единственный источник — уже
      отрендеренный СЕРВЕРОМ боевой блок на этой же странице: кнопки `.bw-prog`
      внутри `#jkBuyWays`. Оттуда берутся и число (`data-rate`), и ПОДПИСЬ ставки
      («6%», «до 6%», «от 17,3%»), и имя программы. Своего списка программ здесь
      нет вовсе.
      Почему так: ставки живут в нескольких витринах сразу и всегда расходятся
      (memory/reference_mortgage_rates_three_surfaces_and_staleness).
      ⛔ Хардкод BANKS в js/mortgage-page.js — УСТАРЕВШИЙ, к нему этот файл не
         обращается ни в каком виде.
      ⛔ Предохранитель по возрасту (app/lib/Mortgage/RatesFreshness.php, пороги
         14 и 42 дня) гасит проценты НА СЕРВЕРЕ: у погашенной программы сервер
         не печатает `data-rate` вовсе. Значит этот список гаснет вместе с боевым
         блоком САМ. Не осталось ни одного процента — блок не рисуется совсем.

   ⛔ ПРОГРАММА БЕЗ ПРОЦЕНТА — БЕЗ ПЛАТЕЖА. У военной («по программе НИС»),
      субсидированной («ставка от застройщика») и «без первого взноса» единой
      ставки не существует. Повторяем ту же мысль словами и не считаем ничего.

   ⛔ ЛИМИТОВ ЛЬГОТНЫХ ПРОГРАММ ЗДЕСЬ НЕТ НАМЕРЕННО (упрощение владельца
      28.08.2026: «делай наши ставки которые есть, не усложняй всё»). Вместо
      ветвления «лимит + остаток по базовой» — одна строка оговорки в подвале.

   ⛔ ДАТА АКТУАЛЬНОСТИ ОБЯЗАТЕЛЬНА. Мы прячем справочные пилюли `.jk-mort-pills`
      (владелец: «оставь только блок калькулятора»), а дату несли именно они.
      Проценты без даты показывать нельзя: по ADR-112 дата и есть предохранитель.
      ⛔ ДАТА У КАЖДОЙ ПРОГРАММЫ СВОЯ — так решено в самом компоненте
         (components/jk-buy-ways.php): «одна общая подпись под числами разного
         происхождения — ровно та ошибка, из-за которой рыночная ставка
         простояла просроченной 47 дней незамеченной». Поэтому: даты у всех
         совпали — печатаем одну в подзаголовке (вид эталона); разошлись —
         подзаголовок остаётся без даты, а каждая строка несёт СВОЮ.
      ⛔ ПИЛЮЛИ ПРЯЧЕМ ТОЛЬКО ПОСЛЕ УСПЕШНОЙ СБОРКИ — классом на секции. Спрячь
         их безусловно, и при любой осечке страница осталась бы со ставками
         калькулятора и БЕЗ единой даты.

   ⛔ ТЕКСТ — ЧЕРЕЗ textContent, УЗЛЫ — ЧЕРЕЗ createElement. Имена программ
      приходят из БД, то есть это чужая строка; innerHTML на ней — дыра.

   ⛔ УПАСТЬ НЕ ИМЕЕМ ПРАВА: нет узла, нет цены, нет ни одной ставки — молча
      выходим, страница остаётся ровно такой, какой была.
   ═══════════════════════════════════════════════════════════════════════════ */
(() => {
    'use strict';

    /* Условия расчёта. Показываются человеку подписью, а не подразумеваются. */
    const DOWN_PCT = 20;
    const TERM_YEARS = 30;

    const el = (tag, cls, text) => {
        const n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text !== undefined && text !== null && text !== '') n.textContent = String(text);
        return n;
    };

    /* Разряды НЕРАЗРЫВНЫМ пробелом — как в остальном интерфейсе: обычный пробел
       рвёт «11 582 510 ₽» по краю строки на телефоне. */
    const sp = (n) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    /**
     * Аннуитет: P = S · i / (1 − (1+i)^(−n)) — та же формула, что у банка.
     * ⛔ Ставка 0 обрушила бы формулу делением на ноль; такой у нас быть не может
     *    (сервер не печатает data-rate="0"), но проверка дешевле разбора.
     */
    const annuity = (sum, ratePct, months) => {
        if (!(sum > 0) || !(months > 0)) return null;
        const i = ratePct / 12 / 100;
        if (!(i > 0)) return sum / months;
        const k = Math.pow(1 + i, -months);
        if (!(k < 1)) return null;
        return sum * i / (1 - k);
    };

    /* Округление платежа до сотен рублей — как просил владелец. */
    const toHundreds = (v) => Math.round(v / 100) * 100;

    /**
     * ⛔ КОМНАТНОСТЬ БЕРЁМ ИЗ АДРЕСА, а не из заголовка страницы: заголовок
     *    выверен под поиск и меняется, адрес — часть роутинга (ADR-125).
     *    Не страница комнатности → null, и подпись говорит про квартиру вообще.
     */
    const ROOMS_RE = /\/kvartiry\/(studii|(\d+)-komnatnye)\/?$/;
    function roomWord() {
        const m = ROOMS_RE.exec(window.location.pathname);
        if (!m) return 'квартиры';
        if (m[1] === 'studii') return 'студии';
        const n = parseInt(m[2], 10);
        return Number.isFinite(n) ? n + '-комнатной' : 'квартиры';
    }

    /**
     * Программы — ИЗ БОЕВОГО БЛОКА, вместе с подписью ставки.
     * ⛔ Нет атрибута — нет и ставки. Пустую строку читать как ноль нельзя:
     *    сервер намеренно не печатает атрибут у программ без процента.
     */
    function readPrograms(bw) {
        const out = [];
        bw.querySelectorAll('.bw-prog').forEach((b) => {
            const name = (b.getAttribute('data-name') || '').trim();
            if (name === '') return;
            const bold = b.querySelector('b');
            const raw = b.getAttribute('data-rate');
            const rate = (raw === null || raw === '') ? null : parseFloat(raw);
            out.push({
                name: name,
                label: bold ? (bold.textContent || '').trim() : '',
                rate: (Number.isFinite(rate) && rate > 0) ? rate : null,
                asOf: '',
            });
        });
        return out;
    }

    /**
     * Дата актуальности каждой программы — из её же справочной пилюли, ДОСЛОВНО.
     * Своего форматирования не заводим: разойтись с боевым блоком нельзя.
     * Пилюли нет — дата пустая, и тогда подписи не будет вовсе.
     */
    function attachDates(progs) {
        const pills = document.querySelectorAll('.jk-mort-pill');
        pills.forEach((pill) => {
            const b = pill.querySelector('b');
            const as = pill.querySelector('.jk-mort-pill__as');
            if (!b || !as) return;
            const name = (b.textContent || '').trim();
            progs.forEach((p) => {
                if (p.name === name) p.asOf = (as.textContent || '').trim();
            });
        });
    }

    function build() {
        const sec = document.getElementById('jkMortgage');
        if (!sec) return;
        const bw = sec.querySelector('#jkBuyWays');
        if (!bw) return;
        const host = bw.parentNode;
        if (!host) return;
        if (sec.querySelector('.jkmr')) return;   /* второй раз не рисуем */

        /* ⛔ ЦЕНА — `data-price-def` БОЕВОГО БЛОКА, И ЭТО ЕДИНСТВЕННЫЙ ИСТОЧНИК.
           Ровно от неё считает калькулятор под нами (значение ползунка цены),
           поэтому наш список и он не могут разойтись. На странице комнатности
           сервер кладёт туда минимум ПО ЭТОЙ ГРУППЕ (JkCardBlocks::flatsAgg
           сужается предикатом группы), на карточке ЖК — минимум по всему дому;
           подпись ниже говорит об этом прямо.
           ⛔ `data-price-min` НЕ годится: это нижняя граница ПОЛЗУНКА
           (половина дефолта), а не цена какой-либо квартиры. */
        const price = parseFloat(bw.getAttribute('data-price-def') || '');
        if (!Number.isFinite(price) || price <= 0) return;

        const progs = readPrograms(bw);
        /* Ни одной ставки — блок не рисуется вовсе. Это и есть «гаснем вместе с
           боевым блоком»: предохранитель по возрасту убирает data-rate на
           сервере, и здесь просто не остаётся, что показывать. */
        if (!progs.some((p) => p.rate !== null)) return;
        attachDates(progs);

        /* Даты программ, у которых есть процент: только их мы и печатаем. */
        const dates = progs.filter((p) => p.rate !== null && p.asOf !== '').map((p) => p.asOf);
        const oneDate = dates.length > 0 && dates.every((d) => d === dates[0]) ? dates[0] : '';

        const loan = price * (100 - DOWN_PCT) / 100;
        const months = TERM_YEARS * 12;

        const box = el('section', 'jkmr');
        box.setAttribute('aria-label', 'Готовые расчёты ипотеки');

        const head = el('div', 'jkmr__head');
        head.appendChild(el('h3', 'jkmr__t', 'Платёж по ипотеке за такую квартиру'));

        const sub = el('p', 'jkmr__sub');
        sub.appendChild(document.createTextNode('Считаем от минимальной цены ' + roomWord() + ' в этом ЖК — '));
        sub.appendChild(el('b', null, sp(price) + ' ₽'));
        sub.appendChild(document.createTextNode(', при взносе ' + DOWN_PCT + '% на ' + TERM_YEARS + ' лет.'));
        head.appendChild(sub);

        if (oneDate !== '') head.appendChild(el('p', 'jkmr__asof', 'Ставки ' + oneDate));
        box.appendChild(head);

        const list = el('ul', 'jkmr__list');
        progs.forEach((p) => {
            const row = el('li', 'jkmr-row' + (p.rate === null ? ' jkmr-row--words' : ''));
            row.appendChild(el('span', 'jkmr-row__name', p.name));

            /* Подпись ставки — ДОСЛОВНО из боевого блока, вместе с приставкой:
               у семейной ставка единая («6%»), у IT постановление задаёт потолок
               («до 6%»), и только рыночная — действительно «от». Собирать эту
               приставку заново значило бы завести второй список с тем же смыслом. */
            const rateCell = el('span', 'jkmr-row__rate');
            rateCell.appendChild(document.createTextNode(p.label || '—'));
            /* Даты разошлись — каждая строка несёт свою (см. шапку файла). */
            if (oneDate === '' && p.rate !== null && p.asOf !== '') {
                rateCell.appendChild(el('small', null, p.asOf));
            }
            row.appendChild(rateCell);

            if (p.rate === null) {
                /* ⛔ Нейтрально и одинаково для всех. Своя причина у каждой
                   («единой ставки нет» у военной, «назначает застройщик» у
                   субсидированной) — это уже утверждение об условиях программы,
                   и оно живёт в боевом блоке, в data-why. */
                row.appendChild(el('span', 'jkmr-row__cond', 'ставку называем под ваш случай'));
                row.appendChild(el('span', 'jkmr-row__pay', 'считаем индивидуально'));
                list.appendChild(row);
                return;
            }

            row.appendChild(el('span', 'jkmr-row__cond',
                'взнос ' + DOWN_PCT + '% · ' + sp(loan) + ' ₽ кредита · ' + TERM_YEARS + ' лет'));
            const pay = annuity(loan, p.rate, months);
            const cell = el('span', 'jkmr-row__pay');
            if (pay === null) {
                cell.textContent = 'считаем индивидуально';
                row.classList.add('jkmr-row--words');
            } else {
                cell.appendChild(document.createTextNode('от ' + sp(toHundreds(pay)) + ' ₽'));
                cell.appendChild(el('small', null, 'в месяц'));
            }
            row.appendChild(cell);
            list.appendChild(row);
        });
        box.appendChild(list);

        /* ⛔ Формулировка не спорит с MORTGAGE_DISCLAIMER_BASE (app/config.php):
           первая и последняя части — она же, дословно по смыслу. Средняя фраза
           про предельные суммы закрывает то, что мы намеренно НЕ считаем
           (лимиты льготных программ), — умолчать о ней значило бы показать
           льготный платёж на сумму, которой программа не даёт. */
        const foot = el('div', 'jkmr__foot');
        foot.appendChild(el('p', 'jkmr__note',
            'Расчёт справочный и не является публичной офертой (ст. 437 ГК РФ). '
            + 'По льготным программам действуют предельные суммы кредита и требования к заёмщику. '
            + 'Окончательные условия (ставка, ПСК, срок, сумма) определяет банк-партнёр при одобрении заявки.'));
        box.appendChild(foot);

        /* ⛔ КНОПКИ «ПОСЧИТАТЬ ПОД СВОЮ СУММУ» НЕТ — снято владельцем 28.08.2026.
           Калькулятор стоит непосредственно под этим блоком, прокручивать к нему
           некуда, а кнопка занимала строку и обещала переход туда, где человек
           уже стоит. */
        host.insertBefore(box, bw);

        /* Пилюли гасим ТОЛЬКО теперь, когда дата уже перенесена наверх. */
        sec.classList.add('jkmr-on');
    }

    const start = () => {
        try {
            build();
        } catch (e) {
            /* Под нами боевая страница — упасть не имеем права. */
        }
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
        start();
    }
})();
